import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { viewDoc } from "../../redux/gestorDocumental/actions";
import { useDispatch } from "react-redux";

const LinkDescargaGD = (props) => {
  //*states
  const [loader, setLoader] = useState(false);
  //*variables
  const dispatch = useDispatch();

  return (
    <li key={props.id} className="d-flex align-items-center"><Button variant="link" disabled={loader} onClick={() => dispatch(viewDoc(props.filters, props.origen, props.cType, setLoader))}>{props.icono ? props.icono : String(props.origen).length > 0 ? `${String(props.origen).substring(0, 30)}...` : props.origen}{ loader ? (<Spinner className="ml-2" animation="border" variant="primary" size="sm" />) : null}</Button></li>
  )
}

export default LinkDescargaGD;
